import type { FilterOperator } from './field-types';
import type { RelativeDateToken } from './view';

/**
 * THE WORDS A FILTER IS READ IN.
 *
 * The AST's operator names are precise and unreadable (`notIn`, `gte`), so every surface
 * that shows a filter to a person needs the same eighteen labels. There were two consumers
 * the day the workflow builder arrived - the filter editor's toolbar sentence
 * (`web/.../filterModel.ts`) and the workflow module's one-line summary (`workflow.ts`) -
 * and two copies of a closed vocabulary is a vocabulary that eventually disagrees with
 * itself.
 *
 * In `shared` rather than in either of them because a workflow condition is rendered on
 * BOTH sides: the browser draws the ONLY IF card, and the server generates the same
 * sentence for the run list and for the tests that pin it (obligation 25). INV-11 makes
 * that free - `shared` ships source, so this is one file and no build step.
 *
 * `Record<FilterOperator, string>` rather than a partial map: adding an operator to the
 * registry is then a compile error here, which is the INV-12 reflex applied to copy.
 */
export const FILTER_OPERATOR_LABELS: Readonly<Record<FilterOperator, string>> = {
  eq: 'is',
  neq: 'is not',
  lt: 'is less than',
  lte: 'is at most',
  gt: 'is greater than',
  gte: 'is at least',
  between: 'is between',
  before: 'is before',
  after: 'is after',
  contains: 'contains',
  notContains: 'does not contain',
  startsWith: 'starts with',
  endsWith: 'ends with',
  in: 'is one of',
  notIn: 'is none of',
  containsAny: 'has any of',
  isEmpty: 'is empty',
  isNotEmpty: 'is not empty',
};

/** `view.ts`'s closed token set, in the words a person reads. */
export const RELATIVE_DATE_LABELS: Readonly<Record<RelativeDateToken, string>> = {
  today: 'Today',
  this_week: 'This week',
  next_7_days: 'The next 7 days',
  this_month: 'This month',
  last_30_days: 'The last 30 days',
};
